(function () {
  function initForSection(section) {
    var swiperContainer = section.querySelector('.swiper-compare-fields');
    if (!swiperContainer) return;

    if (swiperContainer.classList.contains('swiper-initialized')) return;

    // instantiate Swiper (requires global Swiper)
    if (typeof Swiper !== 'undefined') {
      var swiper = new Swiper(swiperContainer, {
        slidesPerView: 1,
        spaceBetween: 0,
        pagination: {
          el: section.querySelector('.swiper-pagination'),
          clickable: true
        },
        navigation: {
          nextEl: section.querySelector('.swiper-button-next'),
          prevEl: section.querySelector('.swiper-button-prev')
        }
      });
    }
  }

  function init() {
    document.querySelectorAll('[data-compare-fields]').forEach(function (el) {
      initForSection(el);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Handle Shopify section load in editor
  document.addEventListener('shopify:section:load', function (event) {
    var section = event.target;
    var compareSection = section.querySelector('[data-compare-fields]');
    if (compareSection) {
      initForSection(compareSection);
    }
  });
})();
